import {createSlice, type SliceSelectors} from '@reduxjs/toolkit'

import {getInitialState} from '@web/slices/saleHistory/slice'

import type {SaleHistoryReducers, MakeCreateSliceOptions} from './interfaces'
import type {SaleHistoryState} from '@web/slices/saleHistory/slice'

export default (options?: MakeCreateSliceOptions) =>
    createSlice<SaleHistoryState, SaleHistoryReducers, 'saleHistory', SliceSelectors<SaleHistoryState>>({
        name: 'saleHistory',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            options?.extraReducers?.(builder)
        },
    })
